import {useCallback, useContext} from "react";
import type {FeeProposalRequestSchemaType} from "@/components/Forms/FeeProposalRequestForm.tsx";
import {jwtInstructorContext} from "@/components/Providers/JWTProvider.tsx";

export type SaveFeeResult = {
    errorCode: number;
    errorMessage?: string;
};

const useSaveFeeProposal = (): ((data: FeeProposalRequestSchemaType) => Promise<Response>) => {
    const {user} = useContext(jwtInstructorContext);

    return useCallback(async (data: FeeProposalRequestSchemaType): Promise<Response> => {
        if (!user) {
            throw new Error("User not authenticated");
        }

        const url = new URL("/v1/fee-requests/save", import.meta.env.VITE_APP_API_ENDPOINT);

        try {
            return await user.apiFetch(url.toString(), {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    ...data,
                    requiresAdditionalInformation: data.requiresAdditionalInformation === "yes",
                    questions: data.questions
                        ? data.questions.map(q => ({
                              ...q,
                              sortOrder: Number(q.sortOrder),
                          }))
                        : data.questions,
                }),
            });
        } catch (error) {
            console.error("Error saving fee proposal:", error);
            throw error;
        }
    }, []);
};

export default useSaveFeeProposal;
